import _filter from "lodash/filter"
import _flatMap from "lodash/flatMap"
import _get from "lodash/get"
import _includes from "lodash/includes"
import _some from "lodash/some"
import {
  TELEFONIA_FIXA,
  TELEFONIA_MOVEL
} from "services/state/billing/constants"

import {
  MENU_BUTTON_OPEN_LINKS_FATURAS,
  MENU_LINK_NAVIGATION_COTA_DADOS,
  MENU_LINK_NAVIGATION_DETALHAMENTO,
  MENU_LINK_NAVIGATION_HOME,
  MENU_LINK_NAVIGATION_INTERFACE_ONLINE,
  MENU_LINK_NAVIGATION_PERFIL_DE_CONSUMO,
  MENU_LINK_NAVIGATION_PRODUTOS,
  MENU_LINK_NAVIGATION_PROTOCOLOS,
  MENU_LINK_NAVIGATION_SHARED_DATA,
  MENU_LINK_NAVIGATION_USERS,
  MENU_LINK_NAVIGATION_VOZ_FIXA
} from "shared/constants/idsElements"
import ENV from "../../../envProperties"

const subItemsProducts = [
  {
    name: "Meus produtos",
    key: "product_management:products",
    icon: "",
    id: "",
    route: {
      href: `${ENV.URL_NEW_B2B}/products`,
      isExternal: true
    },
    operation: {
      type: "PRODUCTS_PLANT",
      obs: "Meus produtos"
    }
  },
  {
    name: "Compartilhe energia",
    key: "product_management:share_energy",
    icon: "",
    id: "",
    route: {
      href: "/share-energy",
      isExternal: false
    },
    operation: {
      type: "PRODUTOS_COMPARTILHE_ENERGIA",
      obs: "Acesso a Compartilhe Energia - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    },
    isNew: true
  },
  {
    name: "Voz Fixa",
    key: "product_management:fixed_voice",
    icon: "",
    id: MENU_LINK_NAVIGATION_VOZ_FIXA,
    route: {
      href: "/fixed-voice",
      isExternal: false
    },
    operation: {
      type: "PRODUTOS_VOZ_FIXA",
      obs: "Acesso a Voz Fixa - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  {
    name: "Compartilhamento de dados",
    key: "product_management:shared_data",
    icon: "",
    id: MENU_LINK_NAVIGATION_SHARED_DATA,
    route: {
      href: "/shared-data",
      isExternal: false
    },
    operation: {
      type: "PRODUTOS_COMPARTILHAMENTO_DADOS",
      obs: "Acesso a Compartilhamento de Dados - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  {
    name: "Detalhamento de chamadas",
    key: "product_management:data_quota",
    icon: "",
    id: MENU_LINK_NAVIGATION_DETALHAMENTO,
    route: {
      href: "/detailing-pos-pre-controle",
      isExternal: false
    },
    operation: {
      type: "PRODUTOS_DETALHAMENTO_CHAMADAS",
      obs: "Acesso a Detalhamento de Chamadas - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  {
    name: "Cota de dados",
    key: "product_management:data_traffic",
    icon: "Traffic",
    id: MENU_LINK_NAVIGATION_COTA_DADOS,
    route: {
      href: "/data-traffic",
      isExternal: false
    },
    operation: {
      type: "PRODUTOS_COTA_DADOS",
      obs: "Acesso a Cota de Dados - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  {
    name: "Perfil de consumo ",
    key: "product_management:consumption-profile",
    icon: "ConsumptionProfile",
    id: MENU_LINK_NAVIGATION_PERFIL_DE_CONSUMO,
    route: {
      href: "/consumption-profile",
      isExternal: false
    },
    operation: {
      type: "PRODUTOS_PERFIL_CONSUMO",
      obs: "Acesso a Perfil de Consumo - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    },
    visible: ({ products }) => {
      const productsData = _get(products, "data", [])
      const productsValid = _flatMap(
        _filter(productsData, (product) => {
          const lineOfBusiness = _get(
            product,
            "productLine.name",
            _get(product, "lineOfBusiness", "")
          )
          return _includes([TELEFONIA_FIXA, TELEFONIA_MOVEL], lineOfBusiness)
        }),
        "products"
      )

      return _some(productsValid, (product) => {
        return product.status !== "CANCELADO" && product.status !== "BLOQUEADO"
      })
    }
  }
]

export const items = (showOnlineInterface) => [
  {
    name: "Home",
    key: "home",
    icon: "Home",
    id: MENU_LINK_NAVIGATION_HOME,
    route: {
      href: `${ENV.URL_NEW_B2B}/`,
      isExternal: true
    },
    operation: {
      type: "MENU_HOME",
      obs: "Acesso a Home - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  {
    name: "Faturas",
    key: "invoices",
    icon: "Invoice",
    id: MENU_BUTTON_OPEN_LINKS_FATURAS,
    route: {
      href: `${ENV.URL_NEW_B2B}/invoices`,
      isExternal: true
    },
    operation: {
      type: "MENU_FATURAS",
      obs: "Clique no título Faturas (Expande/Contrai) - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  {
    name: "Produtos",
    key: "product_management",
    icon: "Product",
    id: MENU_LINK_NAVIGATION_PRODUTOS,
    route: {
      href: "",
      isExternal: false
    },
    showSubItems: true,
    subItems: subItemsProducts,
    operation: {
      type: "MENU_PRODUTOS",
      obs: "Clique no título Produtos (Expande/Contrai) - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  {
    name: "Meus protocolos",
    key: "protocols",
    icon: "Protocol",
    id: MENU_LINK_NAVIGATION_PROTOCOLOS,
    route: {
      href: `${ENV.URL_NEW_B2B}/protocols`,
      isExternal: true
    },
    operation: {
      type: "MENU_MEUS_PROTOCOLOS",
      obs: "Acesso a Meus Protocolos - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  {
    name: "Central do Usuário",
    key: "user_management",
    icon: "Users",
    id: MENU_LINK_NAVIGATION_USERS,
    route: {
      href: `${ENV.URL_NEW_B2B}/users-management`,
      isExternal: true
    },
    operation: {
      type: "MENU_GESTAO_USUARIOS",
      obs: "Clique no título Gestão de usuários (Expande/Contrai) - Menu Lateral",
      shouldTrack: true,
      action: "CLICK",
      integrity: "PENDING",
      numTelefone: ""
    }
  },
  ...(showOnlineInterface
    ? [
        {
          name: "Interface Online",
          key: "interface_online",
          icon: "InterfaceOnline",
          id: MENU_LINK_NAVIGATION_INTERFACE_ONLINE,
          route: {
            href: "/interface-online",
            isExternal: false
          },
          operation: {
            type: "INTERFACE_ONLINE",
            obs: "Interface Online"
          }
        }
      ]
    : [])
]



// WEBPACK FOOTER //
// ./src/components/ModernLayout/Menu/menu.js